import Component from '../../lib/component'

export default class ExternalAnchorComponent extends Component {
    static selector () {
        return ':not(.unstyled):not([class*="btn"])[target=_blank][href^="http"]'
    }

    constructor (opts) {
        super(opts)

        this.render()
    }

    render () {
        if (!this.el.children.length
                && !this.el.classList.contains('text-decoration-none')) {
            this.el.classList
                .add('text-decoration-none')

            this.el.innerHTML = `<span class="border-b transparent-border">${
                this.el.innerHTML}</span>`
        }

        const iconAttrs = ' class="material-icons"'
            + ' style="font-size: 112.5%; min-width: 0px; margin: auto auto auto 0;"'
            + ' aria-hidden="true" data-rendered="true"'

        this.el.classList.add('unstyled')
        this.el.innerHTML = `${this.el.innerHTML} <i${iconAttrs}>launch</i>`
    }
}
